import { ROUTE_PATH, Terminate_reasons_list } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel, SmMetaTextAreaModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class TerminatePopupMetaModel extends FormMetaModel {
    constructor() {
        super('', '', '', 7);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const status_reason = new SmMetaSelectModel(
            'status_reason',
            'status_reason',
            'select',
            true,
            'col-12',
            1,
            1,
            '',
            'select',
            'Reasons',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            Terminate_reasons_list,
            'name',
            'name',
            
        );
        const status_remark = new SmMetaTextAreaModel(
            'status_remark',
            'status_remark',
            'SimpleTextarea',
            false,
            'col-12 ',
            1,
            2,
            '',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            500,
            1,
            false,
            false,
            null,
            "Remarks"
        );


        const buttons = {
            submit: new SmBtnMetaModel('YES', '', true, false, true, true),
            isFormControl: false
        };
        return {
            formInfo,
            buttons,
            status_reason,
            status_remark

        }
    }


}